import { useFormatMenuItem } from "hooks/useFormatMenuItem";
import { Overlay, PanelMenuItem, useTitle } from "modules/common";

const menuItems: PanelMenuItem[] = [
    {
        label: "Analiza Edukacija PG-a",
        link: "https://semis.mps.hr/yiisemis/index.php?r=apprrrPgList/admin",
    },
    {
        label: "Kalendar Edukacija",
        link: "https://semis.mps.hr/yiisemis/index.php?r=karticaTecaja/courseCalendarView",
    },
];

export const EducationAnalysis = () => {
    useTitle("Analiza edukacija - eSavjetnik");
    const formatMenuItem = useFormatMenuItem("education_analysis");

    return (
        <Overlay
            containerClass={formatMenuItem}
            menuItems={menuItems}
            selectFirstMenuItemWhenAvailable
            titleBarProps={{
                fullScreenButton: true,
                newWindowButton: true,
            }}
            view={{
                title: "Analiza edukacija",
                source: item => item?.link ?? "",
            }}
        />
    );
};

export default EducationAnalysis;
